import { AxiosError } from 'axios';
import { POST_MYINFO_TOKEN_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Reponse Model
// =============================================================================
interface PostMyInfoTokenRequest {
  code: string | null;
  state: string | null;
}

type MyInfoDataResponseItemFieldType =
  | 'name'
  | 'uinfin'
  | 'hanyupinyinname'
  | 'sex'
  | 'dob'
  | 'email'
  | 'race'
  | 'secondaryrace'
  | 'nationality'
  | 'residentialstatus'
  | 'occupation'
  | 'mobilenoAreaCode'
  | 'mobilenoPrefix'
  | 'mobilenoDigit'
  | 'homenoAreaCode'
  | 'homenoPrefix'
  | 'homenoDigit'
  | 'registeredAddressBlockNumber'
  | 'registeredAddressFloorNumber'
  | 'registeredAddressUnitNumber'
  | 'registeredAddressStreetNumber'
  | 'registeredAddressPostalCode'
  | 'mobileno' // this field is for SEABMIEB-4215 only, not actual MyInfo fields to display
  | 'regadd'; // this field is for SEABMIEB-4215 only, not actual MyInfo fields to display

export interface MyInfoDataResponseItem {
  field: MyInfoDataResponseItemFieldType;
  value: string;
  code: string;
  editable: boolean;
}

export type PostMyInfoTokenResponse = MyInfoDataResponseItem[];

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess: (data: PostMyInfoTokenResponse) => void;
  onError: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostMyInfoToken = ({ onSuccess, onError }: Input) => {
  const postMyInfoToken = async (reqData: PostMyInfoTokenRequest) => {
    const res = await axiosClient.post<MyInfoDataResponseItem[]>(POST_MYINFO_TOKEN_URL, reqData, {
      timeout: 10000,
    });

    return res.data;
  };

  return useCustomMutation(
    postMyInfoToken,
    {
      onSuccess,
      onError,
    },
    false
  );
};
